import { FC } from "react";
import { styled } from "@mui/material/styles";
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  CheckboxProps,
} from "@mui/material";
import { useField, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import Swal from "sweetalert2";

interface ICheckboxInput {
  name: string;
  label: string;
  disabled?: boolean;
  defaultValue?: boolean;
  onChange?: (e: any) => void;
}

const BpIcon = styled("span")(({ theme }) => ({
  borderRadius: 20,
  width: 20,
  height: 20,
  border: "2px solid #CCC",
  backgroundColor: theme.palette.mode === "dark" ? "#394b59" : "transparent",
  "&:before": {
    display: "block",
    width: 16,
    height: 16,
    padding: "2px",
    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23CCC'/%3E%3C/svg%3E\")",
    content: '""',
  },
  /* "input:hover ~ &": {
    backgroundColor: theme.palette.mode === "dark" ? "#30404d" : "#30404d",
  }, */
  "input:disabled ~ &": {
    boxShadow: "none",
    background:
      theme.palette.mode === "dark"
        ? "rgba(57,75,89,.5)"
        : "rgba(206,217,224,.5)",
  },
  "input:disabled:checked ~ &": {
    boxShadow: "none",
    background: "#5994c2",
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: "#0060aa",
  border: "2px solid transparent",
  backgroundImage:
    "linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))",
  "&:before": {
    display: "block",
    width: 16,
    height: 16,

    backgroundImage:
      "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
      " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
      "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
    content: '""',
  },
});

const CheckboxInputStyle = styled(FormControlLabel)({
  "&.Mui-disabled": {
    span: {
      color:
        localStorage.getItem("dark") === "true"
          ? "rgba(255, 255, 255, 0.38) !important"
          : "rgba(0, 0, 0, 0.38)",
    },
  },
});

function BpCheckbox(props: CheckboxProps) {
  return (
    <Checkbox
      sx={{
        "&:hover": { bgcolor: "transparent" },
      }}
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      inputProps={{ "aria-label": "Checkbox demo" }}
      {...props}
    />
  );
}

const CheckboxIsAuthorizedInput: FC<ICheckboxInput> = ({
  name,
  label,
  disabled,
  defaultValue,
  onChange,
  ...otherProps
}) => {
  const { t } = useTranslation();
  const formik: any = useFormikContext();
  const [field, meta] = useField(name);

  const handleChange = (evt: any) => {
    const { checked } = evt.target;

    const authorized = formik.values?.permissions?.filter(
      (perr: any, a: any) => perr.isAuthorizedSignature
    );
    if (authorized.length > 0 || authorized.length > 1) {
      Swal.fire({
        title: "Uyarı!",
        text: "Sadece 1 tane imza yetkilisi olmalı",
        icon: "warning",
      });

      formik.setFieldValue(name, false);
    } else {
      formik.setFieldValue(name, checked);
    }
  };

  const configCheckbox = {
    ...field,
    checked: field.value,
    onChange: handleChange,
    disabled: disabled ? disabled : false,
  };

  const configFormControl = { error: false };
  const configFormHelperText = { helperText: "" };
  if (meta && meta.error) {
    configFormControl.error = true;
    configFormHelperText.helperText = meta.error;
  }

  return (
    <FormControl {...configFormControl}>
      {/* <FormLabel component="legend">{legend}</FormLabel> */}
      <FormGroup>
        <CheckboxInputStyle
          control={<BpCheckbox {...configCheckbox} />}
          label={label}
        />
      </FormGroup>
      <FormHelperText> {t(configFormHelperText.helperText)} </FormHelperText>
    </FormControl>
  );
};

export default CheckboxIsAuthorizedInput;
